
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import axios from 'axios';

// import Index from './components/Index';

// import Login from './components/login/Login';
// import Flight from './components/flight/Flight';
// import Search from './components/flight/Search';
// import RoundSearch from './components/flight/RoundSearch';
// import Traveldetails from './components/flight/Traveldetails';
// import PaymentPage from './components/flight/Payment';

// import { AuthProvider } from './context/AuthContext';


// axios.defaults.baseURL = "http://127.0.0.1:8081";
// //axios.defaults.baseURL = "https://api.holidayfly.in";
// axios.defaults.headers.post['Content-Type'] = 'application/json';
// axios.defaults.headers.post['Accept'] = 'application/json';
// axios.defaults.withCredentials = true;
// axios.interceptors.request.use(function (config) {
//   const token = localStorage.getItem('auth_token');
//   config.headers.Authorization = token ? `Bearer ${token}` : '';
//   return config;
// });
// function App() {
//   return (
//     <Router>
//       <AuthProvider>
//         <Routes>
//           <Route path="/" element={<Layout />}>
//             <Route path="/" element={<Index />} /> 
//             <Route path="/flight" element={<Flight />} /> 
//             <Route path="//flight/search" element={<Search />} /> 
//             <Route path="//flight/roundsearch" element={<RoundSearch />} /> 
//             <Route path="/traveldetails" element={<Traveldetails />} /> 
//             <Route path="/payment" element={<PaymentPage />} /> 
//             <Route path="/login" element={<Login />} /> 
//             <Route path="*" element={<Error />} />
//           </Route>
//         </Routes>
//       </AuthProvider>
//     </Router>


//   );
// }

// export default App;




import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Login from './components/login/Login';
// import Profile from './components/Profile';
import Index from './components/Index';
import LoyaltyReport from './components/LoyaltyReport';
import FaceDetect from './components/FaceDetect';
import Customer from './components/customer/Customer';
import Store from './components/store/Store';
import LoyaltyCard from './components/loyalty/LoyaltyCard';
import LoyaltyUserCard from './components/loyalty/LoyaltyUserCard';
import LoyaltyUserCardOnlyPrint from './components/loyalty/LoyaltyUserCardOnlyPrint';
import LoyaltyUserCardPrint from './components/loyalty/LoyaltyUserCardPrint';
import LoyaltyRewards from './components/loyalty/LoyaltyRewards';
import LoyaltyRedemption from './components/loyalty/LoyaltyRedemption';
import AddStore from './components/store/AddStore';
import PrivateRoute from './components/PrivateRoute';
import StoreReports from './components/report/StoreReports';
import CustomerReports from './components/report/CustomerReports';
import RewardReports from './components/report/RewardReports';
import Earningbycustomer from './components/report/Earningbycustomer';
import Error from './Error';
import Layout from "./components/Layout";

function App() {
  return (

    <BrowserRouter>
      <AuthProvider>
        <Layout>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Index />
                </PrivateRoute>
              }
            />
            <Route path="/customer" element={<PrivateRoute>  <Customer /> </PrivateRoute>} />
            <Route path="/store" element={<PrivateRoute>  <Store /> </PrivateRoute>} />
            <Route path="/store/add" element={<PrivateRoute> <AddStore key="add" /> </PrivateRoute>} />
            <Route path="/store/edit" element={<PrivateRoute> <AddStore key="edit" /> </PrivateRoute>} />

            <Route path="/loyalty/loyalty_card" element={<PrivateRoute>  <LoyaltyCard /> </PrivateRoute>} />
            <Route path="/loyalty/customer_card" element={<PrivateRoute>  <LoyaltyUserCard /> </PrivateRoute>} />
            <Route path="/loyalty/reward" element={<PrivateRoute>  <LoyaltyRewards /> </PrivateRoute>} />
            <Route path="/loyalty/redemption" element={<PrivateRoute>  <LoyaltyRedemption /> </PrivateRoute>} />
            <Route path="/loyalty/printcards" element={<PrivateRoute>  <LoyaltyUserCardOnlyPrint /> </PrivateRoute>} />
            <Route path="/loyalty/printcard" element={<PrivateRoute>  <LoyaltyUserCardPrint /> </PrivateRoute>} />
            <Route path="/report">
              <Route index element={<PrivateRoute>  <LoyaltyReport /> </PrivateRoute>} />
              <Route path="store" element={<PrivateRoute>  <StoreReports /> </PrivateRoute>} />
              <Route path="customer" element={<PrivateRoute>  <CustomerReports /> </PrivateRoute>} />
              <Route path="reward" element={<PrivateRoute>  <RewardReports /> </PrivateRoute>} />
              <Route path="earningbycustomer" element={<PrivateRoute>  <Earningbycustomer /> </PrivateRoute>} />
            </Route>
            <Route path="/facedetect" element={<PrivateRoute>  <FaceDetect /> </PrivateRoute>} />
            <Route path="*" element={<Error />} />
          </Routes>
        </Layout>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
